import { useEffect, useState, useMemo } from "react";
import { getSharedRoomUsers } from "../../../../services/api/members";
import { debounce } from "../../../utils/search-debounce";
import { useNavigate } from "react-router-dom";

const UseRoomSharingLogic = (eventId) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [initialLoad, setInitialLoad] = useState(true);
    const [selectedHotel, setSelectedHotel] = useState("");
    const navigate = useNavigate();
    const hotelOptions = useMemo(() => {
        const hotels = data.map(item => item.hotel_name);
        return [...new Set(hotels)];
    }, [data]);
    const filteredData = useMemo(() => {
        if (!selectedHotel) return data;

        return data.filter(item => item.hotel_name === selectedHotel);
    }, [data, selectedHotel]);

    const getSearchParams = (text) => {
        if (!text) return {};

        const [product, variation] = text.split("-").map((item) => item.trim());

        return {
            productName: product || undefined,
            variationName: variation || undefined,
        };
    };

    const fetchRoomData = async (text) => {
        try {
            setLoading(true);

            const { productName, variationName } = getSearchParams(text);

            const res = await getSharedRoomUsers(eventId, {
                productName,
                variationName,
            });

            const formattedData =
                res?.data?.map((item) => ({
                    hotel_name: item.product_name,
                    room_type: item.variation_name,
                    sharing_type: item.sharing_type,
                    rooms: item.groups.map((group) => ({
                        label: group.label,
                        users: group.users.map((user) => ({
                            name: user.first_name,
                            location: user.table_name,
                        })),
                    })),
                })) || [];

            setData(formattedData);
        } catch (error) {
            console.error("Error fetching room sharing:", error);
        } finally {
            setLoading(false);
            setInitialLoad(false);
        }
    };

    const debouncedFetch = useMemo(
        () => debounce(fetchRoomData, 500),
        [eventId]
    );
    const handleNavigate = () => {
        navigate(-1);
    };

    useEffect(() => {
        if (eventId) {
            debouncedFetch(searchText);
        }
    }, [searchText, eventId, debouncedFetch]);

    return {
        data: filteredData,
        loading,
        searchText,
        setSearchText,
        handleNavigate,
        initialLoad,
        hotelOptions,
        selectedHotel,
        setSelectedHotel
    };
};

export default UseRoomSharingLogic;

